(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mn-book-hero"] && !Shopify.designMode) return;
  try {
    
/* Get-the-Book: when the book product is purchasable, add its variant to the cart and open the
   drawer; otherwise let the button navigate to the product page. A one-time preflight against
   /products/<handle>.js decides which path to take, and reads the live variant id — so the CTA
   starts working automatically the moment the product is published, with no code change. */
(function () {
  var btns = [].slice.call(document.querySelectorAll('[data-book-add]'));
  if (!btns.length) return;
  var root = window.MNCartRoot || '/';
  var handle = (btns[0].getAttribute('href') || '').split('/products/')[1] || 'miracle-living-book';
  var state = { purchasable: false, vid: null };

  fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (p && p.available) {
        state.purchasable = true;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        state.vid = v && v.id;
      }
    })
    .catch(function () {});

  btns.forEach(function (btn) {
    if (btn.dataset.bookBound) return;
    btn.dataset.bookBound = '1';
    btn.addEventListener('click', function (e) {
      var vid = state.vid || btn.getAttribute('data-variant-id');
      if (!(state.purchasable && vid && window.MNCart && window.MNCart.add)) return; /* let href navigate */
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      Promise.resolve(window.MNCart.add({ variantId: vid, qty: 1 })).then(function () {
        btn.removeAttribute('aria-busy');
      }).catch(function () {
        btn.removeAttribute('aria-busy');
        window.location.href = btn.getAttribute('href');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-bundle"] && !Shopify.designMode) return;
  try {
    
(function(){
  var main=document.getElementById('pf-mainimg'),vid=document.getElementById('pf-video'),stage=document.getElementById('pf-pack');
  document.querySelectorAll('.gthumb').forEach(function(b){b.addEventListener('click',function(){
    document.querySelectorAll('.gthumb').forEach(function(x){x.classList.remove('is-active');});b.classList.add('is-active');
    var isVideo=b.dataset.view==='video';if(stage)stage.classList.toggle('is-video',isVideo);
    if(vid){if(isVideo){if(vid.getAttribute('src')!==b.dataset.video){vid.src=b.dataset.video;}if(b.dataset.poster){vid.poster=b.dataset.poster;}vid.hidden=false;var pr=vid.play();if(pr&&pr.catch){pr.catch(function(){});}}else{vid.pause();vid.hidden=true;}}
    if(main){main.style.display=isVideo?'none':'';if(!isVideo){main.style.opacity='0';setTimeout(function(){main.src=b.dataset.src;main.style.objectFit=b.dataset.fit||'contain';main.style.opacity='1';},120);}}
  });});
  (function(){var rail=document.querySelector('.gallery__rail');if(!rail)return;var thumbs=[].slice.call(rail.querySelectorAll('.gthumb'));if(!thumbs.length)return;
    var pB=document.getElementById('pf-prev'),nB=document.getElementById('pf-next'),sP=document.querySelector('.stripnav--prev'),sN=document.querySelector('.stripnav--next');
    function ai(){var a=rail.querySelector('.gthumb.is-active');return Math.max(0,thumbs.indexOf(a));}
    function rev(t){if(!t)return;var r=rail.getBoundingClientRect(),b=t.getBoundingClientRect();if(b.left<r.left)rail.scrollBy({left:b.left-r.left-8,behavior:'smooth'});else if(b.right>r.right)rail.scrollBy({left:b.right-r.right+8,behavior:'smooth'});}
    function go(d){var n=(ai()+d+thumbs.length)%thumbs.length;thumbs[n].click();rev(thumbs[n]);}
    if(pB)pB.addEventListener('click',function(){go(-1);});if(nB)nB.addEventListener('click',function(){go(1);});
    function st(){return (thumbs[0].getBoundingClientRect().width||66)+9;}
    function up(){if(!sP||!sN)return;sP.disabled=rail.scrollLeft<=2;sN.disabled=rail.scrollLeft>=(rail.scrollWidth-rail.clientWidth-2);}
    if(sP)sP.addEventListener('click',function(){rail.scrollBy({left:-st()*3,behavior:'smooth'});});if(sN)sN.addEventListener('click',function(){rail.scrollBy({left:st()*3,behavior:'smooth'});});
    rail.addEventListener('scroll',up,{passive:true});window.addEventListener('resize',up);up();
  })();
  (function(){var q=document.querySelector('.qty [data-qty-val]');if(!q)return;document.querySelectorAll('.qty [data-step]').forEach(function(btn){btn.addEventListener('click',function(){var n=parseInt(q.value,10)||1;n+=btn.dataset.step==='+'?1:-1;if(n<1)n=1;q.value=n;});});})();
  (function(){var tabs=[].slice.call(document.querySelectorAll('[data-bdtab]'));var pans=[document.getElementById('bd-0'),document.getElementById('bd-1')];tabs.forEach(function(t){t.addEventListener('click',function(){var i=+t.dataset.bdtab;tabs.forEach(function(x){var on=x===t;x.classList.toggle('on',on);x.setAttribute('aria-selected',on?'true':'false');});pans.forEach(function(p,j){if(p)p.style.display=(j===i)?'':'none';});});});})();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-flow"] && !Shopify.designMode) return;
  try {
    
/* Reliable click-to-expand for the lineup flow.
   The shared app.js .flow driver expands a panel only as a side effect of the
   scroll it kicks off with window.scrollTo(); under Shopify's global body overflow
   the page's real scroll container is not the window, so that programmatic scroll is
   a no-op and clicking a row often expands nothing (aria-expanded never flips,
   panel height stays 0). This handler activates the clicked item directly, so the
   panel always opens regardless of the scroll container. On <=820px the CSS already
   shows every panel open, so this is effectively a no-op there. */
(function () {
  var sec = document.getElementById('lineup');
  if (!sec || sec.className.indexOf('flow') === -1) return;
  var items = [].slice.call(sec.querySelectorAll('.flow__item'));
  var slides = [].slice.call(sec.querySelectorAll('.flow__slide'));
  var bar = sec.querySelector('[data-flow-bar]');
  var n = items.length;
  if (!n) return;
  function currentIndex() {
    for (var k = 0; k < n; k++) { if (items[k].classList.contains('on')) return k; }
    return -1;
  }
  function activate(i) {
    if (i < 0 || i >= n) return;
    var prev = currentIndex();
    if (i === prev) return;
    slides.forEach(function (s, j) {
      s.classList.remove('on', 'out');
      if (j === i) s.classList.add('on');
      else if (j === prev) s.classList.add('out');
    });
    items.forEach(function (it, j) {
      it.classList.toggle('on', j === i);
      var b = it.querySelector('.flow__row');
      if (b) b.setAttribute('aria-expanded', j === i ? 'true' : 'false');
    });
    var d = items[i];
    if (d.dataset.bg) { sec.style.background = d.dataset.bg; sec.style.setProperty('--bg', d.dataset.bg); }
    if (d.dataset.fg) { sec.style.color = d.dataset.fg; sec.style.setProperty('--fg', d.dataset.fg); }
    if (d.dataset.ac) sec.style.setProperty('--ac', d.dataset.ac);
    if (bar) bar.style.transform = 'translateX(' + (i * 100) + '%)';
  }
  items.forEach(function (it) {
    var row = it.querySelector('.flow__row[data-flow]');
    if (row) row.addEventListener('click', function () { activate(+row.dataset.flow); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-hero"] && !Shopify.designMode) return;
  try {
    
/* Meta ad message-match: ?a=<angle> rewrites the hero to echo the ad creative. */
(function(){
  var a=(new URLSearchParams(location.search).get('a')||'').toLowerCase();
  if(!a) return;
  var V={
    lowcarb:{h1:'The low-carb pasta<br>you don’t give <span class="pop"><em>up.</em></span>',
      lede:'Egg white &amp; konjac pasta — egg white with 10g protein and under 1g carb, konjac with 1g net carb. Real pasta that fits keto and low-carb, ready to eat.'},
    protein:{h1:'Real pasta with<br>10g of <span class="pop"><em>protein.</em></span>',
      lede:'Egg white pasta from a board-certified doctor — 10g of clean, complete protein per serving, under 1g carb. Full and satisfied, ready to eat.'},
    bloodsugar:{h1:'Pasta without<br>the <span class="pop"><em>flour.</em></span>',
      lede:'Egg white &amp; konjac pasta — high in protein and fiber, low in carb, no refined flour. Open, drain, sauce: ready to eat.'},
    doctor:{h1:'A doctor curated this<br>for his own <span class="pop"><em>patients.</em></span>',
      lede:'Egg white &amp; konjac pasta, curated by Jonathan Carp, MD — clean protein, gentle fiber, low in carb. The pasta he serves his own patients.'}
  };
  V.keto=V.lowcarb; V.steady=V.bloodsugar; V.md=V.doctor;
  var v=V[a]; if(!v) return;
  var h1=document.getElementById('heroH1'), le=document.getElementById('heroLede');
  if(h1&&v.h1) h1.innerHTML=v.h1;
  if(le&&v.lede) le.innerHTML=v.lede;
})();

/* Hero video — kept 1:1 from source; no-ops today since the current hero uses a static image
   (no .hero__video element), retained for parity if a video variant returns. */
(function(){
  var v=document.querySelector('.hero__video'); if(!v) return;
  var m=window.matchMedia('(max-width:700px)').matches;
  if(m && v.getAttribute('data-poster-m')) v.poster=v.getAttribute('data-poster-m');
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var c=navigator.connection;
  if(c && c.saveData) return;
  /* 2026-08-30 mobile audit: hero-film-mob.mp4 is 2.9MB and was fetched synchronously on
     first paint on every phone — the single heaviest asset on the site by 10x, loading in
     direct competition with the LCP. On mobile we now (a) skip the film entirely on 2G/3G,
     where the poster is the better experience anyway, and (b) defer the fetch until the
     browser is idle so it never contends with first paint. Desktop is unchanged. */
  if(m && c && /^([23]g|slow-2g)$/.test(c.effectiveType||'')) return;
  var start=function(){
    v.src=v.getAttribute(m?'data-src-m':'data-src-d'); v.load();
    var p=v.play(); if(p&&p.catch) p.catch(function(){});
  };
  /* Desktop is deferred too: hero-film-desk.mp4 is 4.5MB — larger than the mobile cut and
     99% of everything the desktop page loads over 70KB. It was fetched synchronously at
     first paint, competing with the LCP for bandwidth. Idle-deferring costs nothing
     perceptually (the poster is already painted) and hands the whole pipe to the content. */
  if(window.requestIdleCallback) requestIdleCallback(start,{timeout:m?2500:1200});
  else setTimeout(start,m?1200:600);
})();

/* Sticky mobile buy bar: reveal once the hero has scrolled past, hide again at the top.
   IntersectionObserver on the hero itself, so it stays correct if the hero height changes. */
(function(){
  var bar=document.querySelector('[data-buybar]'); if(!bar) return;
  var hero=document.querySelector('.hero--scene'); if(!hero) return;
  if(!window.matchMedia('(max-width:880px)').matches) return;
  bar.hidden=false;
  var show=function(on){
    bar.classList.toggle('is-on',on);
    document.body.classList.toggle('buybar-on',on);
    if(on) document.documentElement.style.setProperty('--buybar-h',bar.offsetHeight+'px');
  };
  if(!('IntersectionObserver' in window)) return show(true);
  /* The homepage BYO band carries the same CTA, so the bar stands down while it is on
     screen — otherwise the shopper sees the identical button twice. */
  var heroOn=true, bandOn=false;
  var apply=function(){ show(!heroOn && !bandOn); };
  new IntersectionObserver(function(es){ heroOn=es[0].isIntersecting; apply(); },
    {rootMargin:'-40px 0px 0px 0px'}).observe(hero);
  var band=document.querySelector('.byohome');
  if(band) new IntersectionObserver(function(es){ bandOn=es[0].isIntersecting; apply(); },
    {rootMargin:'-60px 0px -60px 0px'}).observe(band);
})();

/* Size the hero to the real viewport below the nav chrome (mudwtr-style single-screen hero). */
(function(){
  var root=document.documentElement;
  function size(){
    var hero=document.querySelector('.hero--scene');
    if(!hero) return;
    var chrome = Math.round(hero.getBoundingClientRect().top + window.scrollY);
    var h = Math.max(420, Math.round(window.innerHeight - chrome));
    root.style.setProperty('--hero-h', h+'px');
  }
  size();
  addEventListener('resize', size, {passive:true});
  addEventListener('load', size);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(size);
})();

/* Hero slider (2026-08-05). No visible controls - it simply auto-advances. Crossfades the
   photo and swaps the H1; everything else in the copy rail holds still so the proof rail
   never flickers. Accessibility backstop: prefers-reduced-motion stops auto-advance dead
   (slide 1 only), and the rotation pauses while a pointer is over the hero. */
(function(){
  var stage=document.querySelector('[data-hero-slider]'); if(!stage) return;
  var slides=[].slice.call(stage.querySelectorAll('.hero__slide'));
  var lines=[].slice.call(document.querySelectorAll('.hero--scene .hero__h1'));
  if(slides.length<2||lines.length<2) return;
  var hero=stage.closest('.hero--scene');
  var dwell=parseInt(stage.getAttribute('data-hero-dwell'),10)||4000;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(reduce) return;
  var i=0,t=null;
  function paint(n){
    i=(n+slides.length)%slides.length;
    slides.forEach(function(s,x){s.classList.toggle('is-on',x===i);});
    lines.forEach(function(s,x){s.classList.toggle('is-on',x===i);});
  }
  function arm(){ clearTimeout(t); t=setTimeout(function(){paint(i+1);arm();},dwell); }
  hero.addEventListener('pointerenter',function(){clearTimeout(t);});
  hero.addEventListener('pointerleave',function(){arm();});
  paint(0); arm();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-pdp-bookend"] && !Shopify.designMode) return;
  try {
    
  /* Bookend CTA: scroll to top, then add the default-selected box to cart */
  var be = document.querySelector('[data-bookend-atc]');
  if (be) {
    be.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      var atc = document.querySelector('[data-atc]'); if (atc) atc.click();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-pdp-details"] && !Shopify.designMode) return;
  try {
    
  var pdtabs = [].slice.call(document.querySelectorAll('[data-pdtab]'));
  var pdpanels = [document.getElementById('pd-nutrition'), document.getElementById('pd-ingredients'), document.getElementById('pd-prepare')];
  pdtabs.forEach(function (t) {
    t.addEventListener('click', function () {
      var i = +t.dataset.pdtab;
      pdtabs.forEach(function (x) { var on = x === t; x.classList.toggle('on', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
      pdpanels.forEach(function (pnl, j) { if (pnl) pnl.classList.toggle('on', j === i); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-pdp-loved"] && !Shopify.designMode) return;
  try {
    
  /* duplicate bowl row for seamless marquee */
  var brow = document.querySelector('[data-bowlrow]');
  if (brow) brow.innerHTML += brow.innerHTML;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  /* ---- Yotpo: real per-product data + live widget (verbatim port of the source PDP) ---- */
  var host = document.querySelector('[data-mnpdp-reviews]');
  if (host) {
    var slug = host.dataset.slug || 'ew-spaghetti';
    var SRC = host.dataset.src;
    var REVIEWS_URL = host.dataset.reviewsUrl || '/pages/reviews';
    var w = document.getElementById('pf-yotpo');
    var set = function (id, v) { var el = document.getElementById(id); if (el) el.textContent = v; };

    /* sync every on-page number to the Yotpo cache (assets/data-yotpo.json) */
    fetch(SRC).then(function (r) { return r.json(); }).then(function (Y) {
      var y = Y[slug] || Y['ew-spaghetti']; if (!y) return;
      var cnt = y.total.toLocaleString();
      set('pf-rating', y.avg.toFixed(1)); set('pf-reviews', cnt);
      set('pf-proofrating', y.avg.toFixed(1)); set('pf-proofreviews', cnt);
      /* corpus-tiles rating line (egg-white-spaghetti) */
      if (document.getElementById('pf-tilerating')) {
        set('pf-tilerating', y.avg.toFixed(1)); set('pf-tilereviews', cnt);
        if (y.dist) set('pf-tilepct', Math.round((y.dist['5'] || 0) / (y.total || 1) * 100));
      }
      /* real histogram in the buy box */
      var h = document.getElementById('pf-histo');
      if (h && y.dist) {
        var tot = y.total || 1, rows = '';
        ['5', '4', '3', '2', '1'].forEach(function (k) {
          var n = y.dist[k] || 0, pc = Math.round(n / tot * 100);
          if (k === '5' || n > 0) rows += '<span><i>' + k + '★</i><b style="width:' + pc + '%"></b><u>' + pc + '%</u></span>';
        });
        h.innerHTML = rows; h.hidden = false;
      }
      /* custom Bang'n-Body-style summary: score + real star distribution bars */
      var rs = document.getElementById('pf-revsum');
      if (rs && y.dist) {
        var tt = y.total || 1;
        var bars = ['5', '4', '3', '2', '1'].map(function (k) {
          var n = y.dist[k] || 0, pc = Math.round(n / tt * 100);
          return '<div class="revsum__row"><span class="revsum__k">' + k + ' ★</span><span class="revsum__bar"><i style="width:' + pc + '%"></i></span><span class="revsum__pc">' + pc + '%</span></div>';
        }).join('');
        rs.innerHTML =
          '<div class="revsum__score"><div class="revsum__num">' + y.avg.toFixed(1) + '</div>' +
          '<div class="revsum__stars">★★★★★</div>' +
          '<div class="revsum__count">' + cnt + ' verified reviews</div></div>' +
          '<div class="revsum__dist">' + bars + '</div>';
        rs.classList.add('is-ready');
      }
      /* buy-box review carousel (mobile): 3 strongest 5★ reviews, ranked by how much
         they talk about flavor, texture, and ingredients. Replaces the count+quote
         teaser on phones (CSS-gated in mn-pdp-mobile.css); desktop never shows it. */
      var car = document.getElementById('pf-revcar');
      if (car && y.reviews && y.reviews.length) {
        /* pdp-cro 2026-10-15: never feature a review flagged "nf" in data-yotpo.json (low stars,
           negative, typo, health/weight claims). They stay in the full list and in every count. */
        var FEAT = y.reviews.filter(function (r) { return !r.nf; });
        var cesc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
        var KW = ['flavor', 'flavour', 'taste', 'tastes', 'texture', 'ingredient', 'delicious', 'love', 'clean', 'protein'];
        var score = function (r) {
          var t = ((r.ti || '') + ' ' + (r.t || '')).toLowerCase(), n = 0;
          KW.forEach(function (k) { if (t.indexOf(k) > -1) n += 1; });
          return n;
        };
        var CURATED = { 'rte-spaghetti': ['New Pantry Staple', 'Excellent product!', 'Best noodles ever!'], 'ew-angelhair': ['We love Miracle Noodles', 'Truly a miracle', 'Ready to go'], 'rte-rice': ['I’m able to eat comfort food again!', 'I am eating ‘Rice’ again!', 'LOVE THIS PRODUCT'] };
        var five;
        var curT = CURATED[slug];
        if (curT) { five = curT.map(function (t) { return FEAT.filter(function (r) { return (r.ti || '') === t && Math.round(r.s || 0) === 5; })[0]; }).filter(Boolean); }
        if (!five || five.length !== 3) {
          five = FEAT.filter(function (r) {
            var len = (r.t || '').length;
            return Math.round(r.s || 0) === 5 && len > 45 && len < 340;
          }).sort(function (a, b) { return score(b) - score(a); }).slice(0, 3);
        }
        if (five.length === 3) {
          car.innerHTML = five.map(function (r) {
            return '<figure class="revcar__card"><div class="revcar__stars" aria-label="5 stars">★★★★★</div>' +
              (r.ti ? '<b class="revcar__title">' + cesc(r.ti) + '</b>' : '') +
              '<blockquote>' + cesc(r.t) + '</blockquote>' +
              '<figcaption>' + cesc(r.n) + ' · Verified buyer</figcaption></figure>';
          }).join('');
/* 2026-07-30 — Chad: keep the SINGLE pull quote and rotate it through the three
             reviews every 4s. The card carousel stays built but hidden, and we no longer add
             'buy__proof--car' (that class hides the quote + rating line on every viewport). */
          car.hidden = true;
          var pq = document.getElementById('pf-proofquote'), pc = document.getElementById('pf-proofcite');
          if (pq && pc && !pq.dataset.rotating) {
            pq.dataset.rotating = '1';
            var bq = pq.closest('blockquote');
            /* prefer three 5-star reviews of similar, readable length so the buy box
               keeps the two-to-three line shape that was signed off */
            var rot = FEAT.filter(function (r) {
              var len = (r.t || '').length;
              return Math.round(r.s || 0) === 5 && len > 60 && len < 200;
            }).sort(function (a, b) { return score(b) - score(a); }).slice(0, 3);
            if (rot.length < 3) rot = five.slice(0, 3);
            var slides = rot.map(function (r) { return { t: r.t || '', n: r.n || 'Verified buyer' }; });
            /* 2026-10-15 \u2014 Chad: rotation overlapped / jumped on iPhone (quote heights differ,
               min-height under-reserved). All slides now sit stacked in one grid cell, so the
               box is always the tallest slide's height (no measuring, no jump), and the fade is
               sequential: old fades out fully before the new one fades in, so text never overlaps. */
            if (bq && slides.length > 1) {
              if (!document.getElementById('pq-stack-css')) {
                var css = document.createElement('style'); css.id = 'pq-stack-css';
                css.textContent = '.pq-stack{display:grid}.pq-slide{grid-area:1/1;opacity:0;visibility:hidden;transition:opacity .35s ease,visibility 0s linear .35s}' +
                  '.pq-slide.is-on{opacity:1;visibility:visible;transition:opacity .35s ease .35s,visibility 0s linear .35s}' +
                  '.pq-slide cite{display:block;font-style:normal;color:var(--sage);font-size:.8rem;margin-top:.3rem}' +
                  '@media(prefers-reduced-motion:reduce){.pq-slide,.pq-slide.is-on{transition:none}}';
                document.head.appendChild(css);
              }
              bq.style.minHeight = '';
              bq.innerHTML = '<div class="pq-stack">' + slides.map(function (s, k) {
                return '<div class="pq-slide' + (k === 0 ? ' is-on' : '') + '"' + (k ? ' aria-hidden="true"' : '') + '>&ldquo;' + cesc(s.t) + '&rdquo; <cite>&mdash; ' + cesc(s.n) + ', verified buyer</cite></div>';
              }).join('') + '</div>';
              var pqs = bq.querySelectorAll('.pq-slide'), pqi = 0, pqPaused = false;
              setInterval(function () {
                if (pqPaused || document.hidden) return;
                pqs[pqi].classList.remove('is-on'); pqs[pqi].setAttribute('aria-hidden', 'true');
                pqi = (pqi + 1) % pqs.length;
                pqs[pqi].classList.add('is-on'); pqs[pqi].removeAttribute('aria-hidden');
              }, 5000);
              bq.addEventListener('mouseenter', function () { pqPaused = true; });
              bq.addEventListener('mouseleave', function () { pqPaused = false; });
              bq.addEventListener('touchstart', function () { pqPaused = true; }, { passive: true });
              slides = [slides[0]]; /* disables the legacy swap/measure path below */
            }
            var draw = function (i) {
              if (!document.body.contains(pq)) return;
              pq.textContent = slides[i].t;
              pc.textContent = '\u2014 ' + slides[i].n + ', verified buyer';
            };
            /* reserve the tallest slide so the buy box never jumps mid-rotation.
               Measure only after webfonts are ready (Zodiak wraps taller than the
               fallback — measuring too early reserved too little and long quotes
               painted over the cite below), and re-measure on resize. */
            var measure = function (keep) {
              if (!bq || slides.length < 2) return;
              bq.style.minHeight = '';
              var maxH = 0;
              for (var mi = 0; mi < slides.length; mi++) { draw(mi); if (bq.offsetHeight > maxH) maxH = bq.offsetHeight; }
              if (maxH) bq.style.minHeight = maxH + 'px';
              draw(keep || 0);
            };
            draw(0);
            if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { measure(0); }); }
            else { measure(0); }
            var rsT; window.addEventListener('resize', function () { clearTimeout(rsT); rsT = setTimeout(function () { measure(qi || 0); }, 200); });
            var qi = 0;
            if (slides.length > 1) {
              var paused = false;
              var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              var step = function () {
                if (paused || document.hidden) return;
                qi = (qi + 1) % slides.length;
                if (reduce || !bq) { draw(qi); return; }
                var swapped = false;
                var doSwap = function () {
                  if (swapped) return; swapped = true;
                  bq.removeEventListener('transitionend', doSwap);
                  draw(qi);
                  requestAnimationFrame(function () { requestAnimationFrame(function () { bq.classList.remove('is-swapping'); }); });
                };
                bq.addEventListener('transitionend', doSwap);
                setTimeout(doSwap, 400); /* fallback if transitionend never fires */
                bq.classList.add('is-swapping');
              };
              setInterval(step, 4000);
              if (bq) {
                var hold = function () { paused = true; }, go = function () { paused = false; };
                bq.addEventListener('mouseenter', hold); bq.addEventListener('mouseleave', go);
                bq.addEventListener('focusin', hold);   bq.addEventListener('focusout', go);
              }
            }
          }
        }
      }

      /* custom review list — Bang'n Body two-column layout + numbered pagination */
      var rl = document.getElementById('pf-rlist'), rp = document.getElementById('pf-rpage');
      if (rl && y.reviews && y.reviews.length) {
        var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
        var all = y.reviews || [], PER = 6, pages = Math.ceil(all.length / PER), page = 0;
        var rowHtml = function (r) {
          var full = Math.round(r.s || 5), stars = '';
          for (var i = 1; i <= 5; i++) stars += '<span class="' + (i <= full ? 'on' : 'off') + '">★</span>';
          var d = (r.d || '').split('-'), date = d.length === 3 ? d[1] + '/' + d[2] + '/' + d[0].slice(2) : '';
          return '<article class="rrow">' +
            '<div class="rrow__meta"><div class="rrow__name">' + esc(r.n) + '</div>' +
            '<div class="rrow__vb">Verified Buyer</div>' +
            '<div class="rrow__stars">' + stars + '</div>' +
            '<time class="rrow__date">' + date + '</time></div>' +
            '<div class="rrow__body">' + (r.ti ? '<h3 class="rrow__title">' + esc(r.ti) + '</h3>' : '') +
            '<p>' + esc(r.t) + '</p></div></article>';
        };
        var pageWindow = function (cur, total) {
          var out = []; if (total <= 7) { for (var i = 0; i < total; i++) out.push(i); return out; }
          out.push(0); var st = Math.max(1, cur - 1), en = Math.min(total - 2, cur + 1);
          if (st > 1) out.push('…'); for (var i = st; i <= en; i++) out.push(i);
          if (en < total - 2) out.push('…'); out.push(total - 1); return out;
        };
        var renderPager = function () {
          if (pages <= 1) { rp.innerHTML = ''; return; }
          var h2 = '<button class="rpg__arw" data-pg="' + (page - 1) + '"' + (page === 0 ? ' disabled' : '') + ' aria-label="Previous">‹</button>';
          pageWindow(page, pages).forEach(function (n) {
            h2 += n === '…' ? '<span class="rpg__dots">…</span>'
              : '<button class="rpg__n' + (n === page ? ' is-active' : '') + '" data-pg="' + n + '"' + (n === page ? ' aria-current="page"' : '') + '>' + (n + 1) + '</button>';
          });
          h2 += '<button class="rpg__arw" data-pg="' + (page + 1) + '"' + (page === pages - 1 ? ' disabled' : '') + ' aria-label="Next">›</button>';
          rp.innerHTML = h2;
          rp.querySelectorAll('[data-pg]').forEach(function (b) { b.addEventListener('click', function () { var t = +b.dataset.pg; if (t >= 0 && t < pages && t !== page) renderPage(t, true); }); });
        };
        var renderPage = function (p, scroll) {
          page = p;
          rl.innerHTML = all.slice(p * PER, p * PER + PER).map(rowHtml).join('');
          renderPager();
          if (scroll) { var tb = document.getElementById('pf-rtabs'); if (tb) tb.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        };
        renderPage(0, false);
      }
    }).catch(function () {});

    /* custom tab toggle: Reviews = the list above, Q&A = the Yotpo widget (Q&A view) */
    (function () {
      var tabs = document.querySelectorAll('#pf-rtabs [data-rtab]');
      var rlEl = document.getElementById('pf-rlist'), yw = document.getElementById('pf-yotpo');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
          t.classList.add('is-active'); t.setAttribute('aria-selected', 'true');
          if (t.dataset.rtab === 'qa') {
            if (rlEl) rlEl.style.display = 'none';
            if (yw) { yw.style.display = 'block'; var qa = [].slice.call(yw.querySelectorAll('.ugc-storefront-widgets-tabs-container__tab')).filter(function (x) { return /Q\s*&\s*A/i.test(x.textContent); })[0]; if (qa) qa.click(); }
          } else {
            if (rlEl) rlEl.style.display = '';
            if (yw) yw.style.display = 'none';
          }
        });
      });
    })();

    /* load the widget script (async, after content) */
    var sc = document.createElement('script'); sc.async = true;
    sc.src = 'https://staticw2.yotpo.com/ZuziAyX60QoGUtOmPXRPXiBqP3aRT2HdJofbLT05/widget.js';
    document.head.appendChild(sc);
    /* graceful fallback: if the widget is blocked (ad/privacy blocker) or fails to load,
       the section never shows an empty gap — it shows the real rating + a link to all reviews */
    if (w) {
      w.innerHTML = '<div class="yfallback" id="pf-yfallback"><div class="yfallback__load">Loading verified reviews…</div></div>';
      var built = false;
      fetch(SRC).then(function (r) { return r.json(); }).then(function (Y) {
        var y = Y[slug] || Y['ew-spaghetti']; if (!y || built) return;
        var fb = document.getElementById('pf-yfallback'); if (!fb) return;
        var pct = y.dist ? Math.round(((y.dist['5'] || 0) + (y.dist['4'] || 0)) / (y.total || 1) * 100) : null;
        fb.innerHTML = '<div class="yfallback__score">' + y.avg.toFixed(1) + '</div>' +
          '<div class="yfallback__b"><div class="yfallback__stars">★★★★★</div>' +
          '<div class="yfallback__count">' + y.total.toLocaleString() + ' verified reviews' + (pct ? ' · ' + pct + '% rate this 4–5★' : '') + '</div>' +
          '<a class="yfallback__cta" href="' + REVIEWS_URL + '">Read all verified reviews →</a></div>';
      }).catch(function () {});
      /* once the real Yotpo widget mounts, it replaces #pf-yotpo content — mark built so fallback stops fighting it */
      var chk = setInterval(function () {
        if (w.querySelector('.yotpo-review') || w.querySelector('.yotpo-bottom-line')) { built = true; clearInterval(chk); }
      }, 400);
      setTimeout(function () { clearInterval(chk); }, 12000);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-pdp"] && !Shopify.designMode) return;
  try {
    
/* mnx card: the terms line wants a compact per-serving figure, not the full meals sentence */
(function(){
  function syncServing(){
    var slot=document.querySelector('[data-mnx-serving]');
    var meals=document.querySelector('.mnx [data-meals]');
    if(!slot||!meals) return;
    /* 2026-09-24: this label sits in the Subscribe card, so price it from the subscription
       first-box price even when One Time is checked (was showing $5.99; audit PDP-02). */
    var sub=document.querySelector('[data-mnbuy] [data-price-sub]'), vin=document.querySelector('[data-mnbuy] input[name="id"]:checked');
    var bags=vin?parseInt(vin.getAttribute('data-bags'),10):0, c=sub?parseFloat((sub.textContent||'').replace(/[^0-9.]/g,'')):0;
    if(bags&&c){ slot.textContent='$'+(Math.round(c*100/bags)/100).toFixed(2)+' / serving'; return; }
    var m=(meals.textContent||'').match(/about\s+(\$[\d.,]+)\s+a meal/i);
    slot.textContent = m ? m[1]+' / serving' : '';
  }
  function arm(){
    syncServing();
    var buy=document.getElementById('buy');
    if(buy){ buy.addEventListener('change',function(){ setTimeout(syncServing,0); }); }
    var meals=document.querySelector('.mnx [data-meals]');
    if(meals && window.MutationObserver){
      new MutationObserver(syncServing).observe(meals,{childList:true,characterData:true,subtree:true});
    }
  }
  if(document.readyState!=='loading') arm(); else document.addEventListener('DOMContentLoaded',arm);
})();
  /* ---- MN PDP buy box (real variants + selling plan; prices from Shopify data only) ---- */
  var root = document.querySelector('[data-mnpdp]');
  var cfgEl = document.querySelector('[data-mnpdp-config]');
  if (root && cfgEl) {
    var CFG = {};
    try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = { variants: [] }; }
    var buy = document.querySelector('[data-mnbuy]');
    var fmt = function (cents) { return '$' + (cents / 100).toFixed(2); };
    var byId = {};
    (CFG.variants || []).forEach(function (v) { byId[String(v.id)] = v; });

    var freqSel = buy ? buy.querySelector('[data-freq]') : null;
    var planId = function () { return freqSel ? +freqSel.value : (CFG.planFirst ? +CFG.planFirst : null); };
    var eff = function () {
      var vin = buy.querySelector('input[name="id"]:checked');
      var rec = vin ? byId[vin.value] : null;
      var plan = buy.querySelector('input[name="plan"]:checked');
      var isSub = !!(plan && plan.value === 'sub');
      var full = rec ? rec.price : 0;
      var pid = planId();
      var sub = full;
      if (rec && rec.subs) { sub = rec.subs[String(pid)] != null ? rec.subs[String(pid)] : (Object.values(rec.subs)[0] != null ? Object.values(rec.subs)[0] : full); }
      /* first-order price: the "20% off your first order" automatic discount takes 12%
         off the sub price at checkout (ladder products only) — mirror its rounding */
      var first = CFG.firstbox ? sub - Math.round(sub * 0.12) : sub;
      return { rec: rec, vin: vin, isSub: isSub, full: full, sub: sub, first: first, price: isSub ? first : full, bags: rec ? rec.bags : 0, pid: pid };
    };
    var qtyNow = function () {
      var el = buy ? buy.querySelector('[data-qty-val]') : null;
      return el ? (parseInt(el.textContent, 10) || 1) : 1;
    };
    var recalc = function (animate) {
      if (!buy) return;
      var s = eff();
      var q = qtyNow();
      var onceEl = buy.querySelector('[data-price-once]'); if (onceEl) onceEl.textContent = fmt(s.full);
      var fullEl = buy.querySelector('[data-price-full]'); if (fullEl) fullEl.textContent = fmt(s.full);
      var subEl = buy.querySelector('[data-price-sub]'); if (subEl) subEl.textContent = fmt(s.first);
      var afterEl = buy.querySelector('[data-sub-after]'); if (afterEl) afterEl.textContent = fmt(s.sub);
      /* the mnx card's struck-through compare price and its "first N-pack box" caption were
         server-rendered only. With the 6/12 pills back (2026-07-30) they must follow the
         selected variant, or a 12-pack shows the 6-pack's $35.94 crossed out beside it. */
      var flb = buy.querySelector('[data-freq-label]');
      if (flb && freqSel) { var fp = buy.querySelector('[data-freq-pill].is-on'); if (fp) flb.textContent = 'every ' + fp.dataset.planName; }
      var cmpEl = buy.querySelector('[data-compare-sub]'); if (cmpEl) cmpEl.textContent = fmt(s.full);
      var pkEl = buy.querySelector('[data-mnx-packlabel]');
      if (pkEl) pkEl.textContent = s.bags > 1 ? 'first ' + s.bags + '-pack box' : 'first box';
      var subInlineEl = buy.querySelector('[data-price-sub-inline]'); if (subInlineEl) subInlineEl.textContent = fmt(s.first);
      var fsaveEl = buy.querySelector('[data-first-save]'); if (fsaveEl) fsaveEl.textContent = fmt(s.full - s.first);
      buy.querySelectorAll('input[name="id"]').forEach(function (v) {
        var tp = v.parentElement.querySelector('[data-tileprice]');
        if (!tp) return;
        var rec = byId[v.value]; if (!rec) return;
        tp.innerHTML = (rec.bags > 0)
          ? '<b>' + fmt(rec.price) + '</b><i>' + fmt(Math.round(rec.price / rec.bags)) + '/bag</i>'
          : '<b>' + fmt(rec.price) + '</b>';
      });
      /* 2026-09-24: with One Time Purchase checked, the pack tiles kept quoting subscription
         first-box prices while the button said $35.94 (audit PDP-02). Show one-time prices then. */
      buy.querySelectorAll('.mnx-pack').forEach(function (t) {
        var inp = t.querySelector('input[name="id"]'), pr = t.querySelector('.mnx-pack__pr'), pp = t.querySelector('.mnx-pack__pp');
        if (!inp || !pr || !pp) return;
        if (pr.dataset.subHtml == null) { pr.dataset.subHtml = pr.innerHTML; pp.dataset.subHtml = pp.innerHTML; }
        if (s.isSub) { pr.innerHTML = pr.dataset.subHtml; pp.innerHTML = pp.dataset.subHtml; }
        else { var p = +inp.dataset.price, b = parseInt(inp.dataset.bags, 10) || 1; pr.textContent = fmt(p); pp.textContent = 'one-time \u00b7 ' + fmt(Math.round(p / b)) + '/pouch'; }
      });
      var mealsEl = buy.querySelector('[data-meals]');
      if (mealsEl && s.bags) mealsEl.textContent = s.bags + ' meals · about ' + fmt(Math.round(s.price / s.bags)) + ' a meal' + (s.isSub ? ' · save ' + fmt(s.full - s.price) + ' today' : '');
      var cadEl = buy.querySelector('[data-cadence]'); if (cadEl) cadEl.style.display = s.isSub ? '' : 'none';
      var atcLabel = buy.querySelector('[data-atc-label]'); if (atcLabel) atcLabel.textContent = atcLabel.hasAttribute('data-atc-plain') ? 'Add to cart' : 'Add to cart · ' + fmt(s.price * q);
      var stickyPrice = document.querySelector('[data-sticky-price]'); if (stickyPrice) stickyPrice.textContent = (s.bags ? s.bags + '-pack · ' : '') + (s.isSub ? 'Subscribe · ' : '') + fmt(s.price * q);
      var stickyBtn = document.querySelector('[data-sticky-atc]'); if (stickyBtn) stickyBtn.textContent = 'Add to cart';
      if (animate) {
        buy.querySelectorAll('[data-price-once],[data-price-sub],[data-atc-label],[data-tileprice]').forEach(function (el) {
          el.classList.remove('numpop'); void el.offsetWidth; el.classList.add('numpop');
        });
      }
    };
    if (buy) {
      buy.querySelectorAll('input[name="id"],input[name="plan"],[data-freq]').forEach(function (i) { i.addEventListener('change', function () { recalc(true); }); });
      buy.querySelectorAll('[data-freq-pill]').forEach(function (b) {
        b.addEventListener('click', function () {
          buy.querySelectorAll('[data-freq-pill]').forEach(function (x) { x.classList.remove('is-on'); });
          b.classList.add('is-on');
          if (freqSel) freqSel.value = b.dataset.planId;
          var sr = buy.querySelector('input[name="plan"][value="sub"]'); if (sr) sr.checked = true;
          recalc(true);
        });
      });
      recalc();
      var qty = buy.querySelector('[data-qty]');
      if (qty) {
        var val = qty.querySelector('[data-qty-val]');
        qty.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(val.textContent, 10) + (b.dataset.step === '+' ? 1 : -1);
            val.textContent = Math.max(1, n);
            recalc(true);
          });
        });
      }
      /* ATC: POST /cart/add.js (+ selling_plan when subscribing) through the Phase 1
         cart drawer. MNCart.add resolves "<slug>-<bags>" → variant id, passes
         item.selling_plan through to the payload, and refreshes/opens the drawer. */
      var cartAdd = function (s, qtyVal) {
        if (!window.MNCart) return;
        /* Pass the exact Shopify variant id (variantId) so ATC works for EVERY product,
           including generic/unmapped ones not present in MNCatalog. id kept for legacy
           MNCatalog resolution of the 6 mapped products. */
        var item = { id: CFG.slug + '-' + s.bags, name: CFG.name, qty: qtyVal };
        if (s.rec && s.rec.id) item.variantId = s.rec.id;
        if (s.isSub && s.pid) item.selling_plan = s.pid;
        return window.MNCart.add(item);
      };
      var atc = buy.querySelector('[data-atc]');
      if (atc) atc.addEventListener('click', function () {
        var s = eff();
        var qtyVal = parseInt((buy.querySelector('[data-qty-val]') || {}).textContent || '1', 10) || 1;
        cartAdd(s, qtyVal);
        atc.classList.add('is-added');
        var lbl = atc.querySelector('span');
        var orig = lbl.textContent; lbl.textContent = 'Added ✓ · ' + fmt(s.price * qtyVal);
        setTimeout(function () { atc.classList.remove('is-added'); lbl.textContent = orig; }, 1700);
      });
      var stickyAtc = document.querySelector('[data-sticky-atc]');
      if (stickyAtc) stickyAtc.addEventListener('click', function (e) { e.preventDefault(); if (atc) atc.click(); });
    }

    /* sticky mobile ATC visibility (+ body class so the global-chrome askbot launcher
       can yield — the source's `#stickyAtc.show ~ .askbot` sibling selector cannot
       match across Shopify section wrappers) */
    var sa = document.getElementById('stickyAtc');
    var atcWatch = document.querySelector('[data-atc]') || document.getElementById('buy');
    if (sa && atcWatch) {
      var updateSticky = function () {
        var past = atcWatch.getBoundingClientRect().top < 0;      /* scrolled past the main ATC */
        var deep = window.scrollY > (window.innerHeight * 2);     /* owner 2026-07-24: hold the sticky ATC until ~2 viewport scrolls */
        var show = past && deep;
        sa.classList.toggle('show', show);
        document.body.classList.toggle('mn-sticky-atc-on', show);
      };
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      updateSticky();
    }

    /* Meta ad message-match ribbon: ?a=<angle> echoes the ad creative at the buy box */
    (function () {
      var ang = (new URLSearchParams(location.search).get('a') || '').toLowerCase();
      var ANG = { lowcarb: 'Low-carb & keto · 1g net carbs', keto: 'Low-carb & keto · 1g net carbs',
        protein: 'High-protein · 10g per serving', bloodsugar: 'No refined flour', steady: 'No refined flour',
        doctor: 'Curated by a doctor', md: 'Curated by a doctor' };
      if ((CFG.slug || '').indexOf('ew') === 0) { for (var k in ANG) ANG[k] = ANG[k].replace('1g net carbs', '<1g carb'); }
      var ae = document.getElementById('pf-angle');
      if (ae && ANG[ang]) { ae.textContent = ANG[ang]; ae.hidden = false; }
    })();

    /* gallery: click a thumbnail to swap the main image (Graza-style) */
    (function () {
      var main = document.getElementById('pf-mainimg');
      var spin = document.getElementById('pf-spin');
      var vid  = document.getElementById('pf-video');
      var stage = document.getElementById('pf-pack');
      /* the badge belongs to the pack photo — on the info panels it lands on top of their
         own headline (caught on mobile 2026-09-01), so it hides on every non-pack view */
      var flagEl = document.getElementById('pf-flag');
      var flagHasContent = !!(flagEl && !flagEl.hasAttribute('hidden'));
      document.querySelectorAll('.gthumb').forEach(function (b) {
        b.addEventListener('click', function () {
          document.querySelectorAll('.gthumb').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          var isSpin  = b.dataset.view === 'spin';
          var isVideo = b.dataset.view === 'video';
          if (stage) stage.classList.toggle('is-video', isVideo);  // portrait 9:16 stage while a video plays (no side bars, no dead space)
          if (spin) spin.hidden = !isSpin;                 // 360 view sits above the static image
          if (vid) {
            if (isVideo) {
              if (vid.getAttribute('src') !== b.dataset.video) { vid.src = b.dataset.video; }
              if (b.dataset.poster) { vid.poster = b.dataset.poster; }
              vid.hidden = false;
              var pr = vid.play(); if (pr && pr.catch) { pr.catch(function () {}); }  // sound-on: play() is user-gesture initiated
            } else {
              vid.pause(); vid.hidden = true;
            }
          }
          if (main) {
            main.style.display = (isSpin || isVideo) ? 'none' : '';     // hide the static photo while spinning or playing (no bleed-through)
            if (!isSpin && !isVideo) { main.style.opacity = '0'; setTimeout(function () { main.src = b.dataset.src; main.style.objectFit = b.dataset.fit || 'contain'; main.style.opacity = '1'; }, 120); }
          }
          if (flagHasContent) {
            var packView = !b.dataset.view && (b.id === '' || b.id === 'pf-thumb-front' || b.id === 'pf-thumb-back');
            flagEl.hidden = !packView;
          }
        });
      });
    })();

    /* gallery nav — on-image prev/next cycles slides; strip arrows scroll the horizontal thumbnail strip */
    (function () {
      var rail = document.querySelector('.gallery__rail'); if (!rail) return;
      var thumbs = [].slice.call(rail.querySelectorAll('.gthumb'));
      if (!thumbs.length) return;
      var prevBtn = document.getElementById('pf-prev'), nextBtn = document.getElementById('pf-next');
      var sPrev = document.querySelector('.stripnav--prev'), sNext = document.querySelector('.stripnav--next');
      function activeIndex() { var a = rail.querySelector('.gthumb.is-active'); return Math.max(0, thumbs.indexOf(a)); }
      function reveal(t) { if (!t) return; var r = rail.getBoundingClientRect(), b = t.getBoundingClientRect();
        if (b.left < r.left) rail.scrollBy({ left: b.left - r.left - 8, behavior: 'smooth' });
        else if (b.right > r.right) rail.scrollBy({ left: b.right - r.right + 8, behavior: 'smooth' }); }
      function go(delta) { var n = (activeIndex() + delta + thumbs.length) % thumbs.length; thumbs[n].click(); reveal(thumbs[n]); }
      if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

      /* swipe / drag the image itself to change slides (2026-07-30) */
      (function () {
        var stage = document.getElementById('pf-pack') || document.querySelector('.gallery__stage');
        if (!stage) return;
        var x0 = null, y0 = null, dragging = false, moved = 0;
        var THRESH = 40;            // px before it counts as a swipe
        var SLOP = 1.2;             // horizontal must beat vertical by this much, so page scroll still works

        function start(x, y) { x0 = x; y0 = y; dragging = true; moved = 0; stage.classList.add('is-dragging'); }
        function move(x, y) {
          if (!dragging || x0 === null) return false;
          var dx = x - x0, dy = y - y0;
          moved = Math.abs(dx);
          if (Math.abs(dy) > Math.abs(dx)) { end(); return false; }   // vertical intent -> let the page scroll
          stage.style.setProperty('--drag', Math.max(-60, Math.min(60, dx)) + 'px');
          return Math.abs(dx) > Math.abs(dy) * SLOP;
        }
        function finish(x) {
          if (!dragging || x0 === null) return;
          var dx = x - x0;
          end();
          if (Math.abs(dx) > THRESH) go(dx < 0 ? 1 : -1);
        }
        function end() { dragging = false; x0 = y0 = null; stage.classList.remove('is-dragging'); stage.style.removeProperty('--drag'); }

        stage.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          start(e.touches[0].clientX, e.touches[0].clientY);
        }, { passive: true });
        stage.addEventListener('touchmove', function (e) {
          if (!dragging) return;
          if (move(e.touches[0].clientX, e.touches[0].clientY) && e.cancelable) e.preventDefault();
        }, { passive: false });
        stage.addEventListener('touchend', function (e) {
          finish((e.changedTouches[0] || {}).clientX || 0);
        }, { passive: true });
        stage.addEventListener('touchcancel', end, { passive: true });

        // desktop drag, without breaking clicks on the arrows or thumbnails
        stage.addEventListener('mousedown', function (e) {
          if (e.button !== 0 || e.target.closest('.gnav')) return;
          start(e.clientX, e.clientY); e.preventDefault();
        });
        window.addEventListener('mousemove', function (e) { if (dragging) move(e.clientX, e.clientY); });
        window.addEventListener('mouseup', function (e) { if (dragging) finish(e.clientX); });

        stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
      })();
      function step() { return (thumbs[0].getBoundingClientRect().width || 66) + 9; }
      function updateStrip() { if (!sPrev || !sNext) return;
        sPrev.disabled = rail.scrollLeft <= 2;
        sNext.disabled = rail.scrollLeft >= (rail.scrollWidth - rail.clientWidth - 2);
      }
      if (sPrev) sPrev.addEventListener('click', function () { rail.scrollBy({ left: -step() * 3, behavior: 'smooth' }); });
      if (sNext) sNext.addEventListener('click', function () { rail.scrollBy({ left: step() * 3, behavior: 'smooth' }); });
      rail.addEventListener('scroll', updateStrip, { passive: true });
      window.addEventListener('resize', updateStrip);
      updateStrip();
    })();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-recipe-article"] && !Shopify.designMode) return;
  try {
    
(function(){
  var art = document.querySelector('[data-rc]');
  if(!art) return;
  art.classList.add('rc-js'); /* JS present -> hide legacy until JSON resolves */

  /* article.handle can render blog-prefixed (e.g. "recipes/<slug>") on this store;
     normalize to the final path segment so it matches data-recipes.json slugs. */
  var handle  = (art.dataset.handle || '').split('/').pop();
  var DATA    = art.dataset.datasrc;
  var FALLIMG = art.dataset.fallimg || '';
  var SHOPURL = art.dataset.shopurl || '/collections/all';
  /* assets/ base derived from the data asset URL (recipe images use the img- flatten rule:
     images/recipes/<slug>.webp -> img-recipes-<slug>.webp) */
  var ASSETBASE = DATA.split('?')[0].replace(/[^/]+$/, '');
  function recipeImg(slug){ return ASSETBASE + 'img-recipes-' + slug + '.webp'; }

  function showLegacy(){ art.classList.add('is-legacy'); }
  var esc = function(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;'); };

  var KEY = 'mn_recipe_' + handle;
  var saved = { ing:[], step:[] };
  try { var s = JSON.parse(localStorage.getItem(KEY)); if(s && s.ing && s.step) saved = s; } catch(e){}
  var save = function(){ try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch(e){} };

  fetch(DATA).then(function(r){ return r.json(); }).then(function(all){
    var rc = all.filter(function(x){ return x.slug === handle; })[0];
    if(!rc){ showLegacy(); return; }           /* no match -> graceful prose */

    art.classList.add('is-structured');
    document.title = rc.title + ' — Miracle Noodle';

    var img = document.getElementById('rc-img');
    img.src = recipeImg(rc.slug);
    img.alt = rc.title;
    if(FALLIMG){ img.addEventListener('error', function onerr(){ img.removeEventListener('error', onerr); img.src = FALLIMG; }); }

    document.getElementById('rc-title').textContent = rc.title;
    document.getElementById('rc-dek').textContent   = rc.dek || '';
    document.getElementById('rc-tags').textContent  = (rc.tags||[]).join(' · ');
    document.getElementById('rc-tip').textContent   = rc.tip || '';
    document.getElementById('rc-meta').innerHTML =
      ['Serves '+rc.serves, '~'+rc.timeMin+' min', esc(rc.product)].map(function(m){ return '<li>'+m+'</li>'; }).join('');

    var cat = window.MNCatalog || {};
    var shop = document.getElementById('rc-shop');
    if(rc.productSlug && cat[rc.productSlug] && cat[rc.productSlug].url){ shop.href = cat[rc.productSlug].url; }
    else { shop.href = SHOPURL; }

    /* Brez-style: the product used, with a direct add-to-cart (real Shopify cart) */
    (function(){
      var ps = rc.productSlug, use = document.getElementById('rc-use');
      if(!ps || !use) return;
      var c = cat[ps]; if(!c || !c.img || !c.name || !c.p6) return;
      document.getElementById('rc-use-img').src = c.img;
      document.getElementById('rc-use-name').textContent = c.name;
      document.getElementById('rc-use-price').textContent = '$' + Number(c.p6).toFixed(2);
      use.hidden = false;
      var add = document.getElementById('rc-use-add');
      add.addEventListener('click', function(){
        if(window.MNCart) window.MNCart.add({ id: ps+'-6', name: c.name, price: c.p6, img: c.img, variant: '6-Pack', qty: 1 });
        add.textContent = 'Added ✓'; setTimeout(function(){ add.textContent = 'Add to cart →'; }, 1400);
      });
    })();

    function updateCount(id,bucket,total){ document.getElementById(id).textContent = saved[bucket].length + ' of ' + total; }
    function markCurrent(){
      var lis = document.querySelectorAll('#rc-steps li');
      lis.forEach(function(li){ li.classList.remove('is-current'); });
      for(var i=0;i<lis.length;i++){ var row=lis[i].querySelector('.rc__row'); if(row && !row.classList.contains('is-checked')){ lis[i].classList.add('is-current'); break; } }
    }
    /* sub-recipe headers (audit 2026-07-13): source data inlines lines like
       "DIRECTIONS: Miracle Noodle Ziti" as steps — render them as non-checkable
       group headers instead of checklist rows */
    var isHead = function(t){ return /^(directions|ingredients|for the )/i.test(t) && t.length < 60 || (/:$/.test(t) && t.length < 48); };
    function renderList(elId,countId,items,bucket,ordered){
      var el = document.getElementById(elId);
      var checkable = items.filter(function(t){ return !isHead(t); }).length;
      el.innerHTML = items.map(function(t,i){
        if(isHead(t)) return '<li class="rc__subhead" aria-hidden="false">'+esc(t.replace(/^directions:\s*/i,'').replace(/:$/,''))+'</li>';
        var on = saved[bucket].indexOf(i) > -1;
        return '<li><button class="rc__row'+(on?' is-checked':'')+'" role="checkbox" aria-checked="'+on+'" data-i="'+i+'"><span class="rc__box" aria-hidden="true"></span><span class="rc__txt">'+esc(t)+'</span></button></li>';
      }).join('');
      items = { length: checkable };
      el.querySelectorAll('.rc__row').forEach(function(b){
        b.addEventListener('click', function(){
          var i = +b.dataset.i, arr = saved[bucket], k = arr.indexOf(i);
          if(k>-1){ arr.splice(k,1); b.classList.remove('is-checked'); b.setAttribute('aria-checked','false'); }
          else { arr.push(i); b.classList.add('is-checked'); b.setAttribute('aria-checked','true'); }
          save(); updateCount(countId,bucket,items.length); if(ordered) markCurrent();
        });
      });
      updateCount(countId,bucket,items.length); if(ordered) markCurrent();
    }
    renderList('rc-ings','rc-ingcount',rc.ingredients,'ing',false);
    renderList('rc-steps','rc-stepcount',rc.steps,'step',true);

    var allBtn = document.querySelector('[data-checkall="ing"]');
    var syncAllLabel = function(){ allBtn.textContent = (saved.ing.length===rc.ingredients.length && rc.ingredients.length) ? 'Uncheck all' : 'Check all'; };
    allBtn.addEventListener('click', function(){
      var allOn = saved.ing.length === rc.ingredients.length;
      saved.ing = allOn ? [] : rc.ingredients.map(function(_,i){ return i; }); save();
      renderList('rc-ings','rc-ingcount',rc.ingredients,'ing',false); syncAllLabel();
    });
    syncAllLabel();
    document.querySelector('[data-reset]').addEventListener('click', function(){
      saved = { ing:[], step:[] }; save();
      renderList('rc-ings','rc-ingcount',rc.ingredients,'ing',false);
      renderList('rc-steps','rc-stepcount',rc.steps,'step',true); syncAllLabel();
    });

    /* Keep screen on (Wake Lock) */
    var lock = null, wbtn = document.querySelector('[data-wake]');
    if(wbtn) wbtn.addEventListener('click', function(){
      if(!('wakeLock' in navigator)){ wbtn.textContent = 'Not supported'; wbtn.disabled = true; return; }
      if(lock){ lock.release().catch(function(){}); lock = null; wbtn.setAttribute('aria-pressed','false'); wbtn.textContent = 'Keep screen on'; }
      else { navigator.wakeLock.request('screen').then(function(l){ lock = l; wbtn.setAttribute('aria-pressed','true'); wbtn.textContent = 'Screen stays on ✓'; l.addEventListener('release', function(){ wbtn.setAttribute('aria-pressed','false'); wbtn.textContent = 'Keep screen on'; lock = null; }); }).catch(function(){}); }
    });
    document.addEventListener('visibilitychange', function(){ if(lock && document.visibilityState==='visible'){ navigator.wakeLock.request('screen').then(function(l){ lock = l; }).catch(function(){}); } });
  }).catch(function(){ showLegacy(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-reviews-wall"]) return;
  try {
    
/* +42 additional real verified reviews (from the Yotpo export) appended to the wall, before filtering runs */
(function(){
  var wall=document.querySelector('.rev-wall'); if(!wall) return;
  var MORE=[{"n": "Shay", "t": "These are the closest thing to real noodles I've tried. They are packed with protein and easy to use. Love them!", "cat": "egg", "prod": "Egg White Spaghetti"}, {"n": "GLORIA B.", "t": "This pasta is so good to me and if you love pasta like I do it's a great product without all the calories. Love it !!!", "cat": "egg", "prod": "Egg White Spaghetti"}, {"n": "Lynette D.", "t": "Love these noodles and they're so easy, just pour out of bag and add your favorite sauce, absolutely DELICIOUS!", "cat": "egg", "prod": "Egg White Spaghetti"}, {"n": "Michelle H.", "t": "So versatile and easy to add 10g of protein to a meal. Put it in miso, chili, soups and sauces. It's really convenient.", "cat": "egg", "prod": "Egg White Spaghetti"}, {"n": "Nancy", "t": "I love these \"Noodles\"! I can feel like I'm having pasta, without the carbs. Please don't ever stop making this. Thanks!", "cat": "egg", "prod": "Egg White Spaghetti"}, {"n": "Shoni M.", "t": "These were way better than I expected. They hold up really well in sauce and even reheated. Taste really good.", "cat": "egg", "prod": "Egg White Spaghetti"}, {"n": "Michael W.", "t": "I have looked for years and this is by far the best low carb noodle I've ever had. I will continue to buy them, so good!", "cat": "egg", "prod": "Egg White Spaghetti"}, {"n": "Patricia", "t": "Wonderful! I used to make my own, and these are easier and quicker. Dry them out in a pan and they taste like pasta!", "cat": "egg", "prod": "Egg White Spaghetti"}, {"n": "Ri P.", "t": "I have been using this product for several years. It is a great substitute for regular pasta. I highly recommend it.", "cat": "konjac", "prod": "Angel Hair"}, {"n": "Carol B.", "t": "I use these almost every day for dinner. The texture is perfect, and I rave about them to anyone who will listen.", "cat": "konjac", "prod": "Angel Hair"}, {"n": "Mariah R.", "t": "With the variety pack the possibilities are endless, and I never feel guilty eating a huge bowl of my favorite pasta.", "cat": "konjac", "prod": "Angel Hair"}, {"n": "Tammy W.", "t": "I love this angel hair pasta — super for stir-fries, and even better in the cold winter months to make chicken soup!", "cat": "konjac", "prod": "Angel Hair"}, {"n": "Allura L.", "t": "I use these noodles with my spaghetti sauce and my thai peanut sauce — they work perfectly every time!", "cat": "konjac", "prod": "Angel Hair"}, {"n": "Karen", "t": "I love these noodles. Super easy to prepare and perfect for soups or Asian-style dishes without all of the carbs.", "cat": "konjac", "prod": "Angel Hair"}, {"n": "Tere E.", "t": "I love that it's easy to prepare and quick, and I can use it in all kinds of recipes — and it has almost zero carbs.", "cat": "konjac", "prod": "Angel Hair"}, {"n": "Catherine S.", "t": "Zero calories and close to zero grams of carbs. Truly a miracle, and I'm enjoying noodles again after many years.", "cat": "konjac", "prod": "Angel Hair"}, {"n": "Jacalyn G.", "t": "Before I ran out I had to order more, fearing I might be without. Great stuff, good for us, delicious, and versatile.", "cat": "konjac", "prod": "Fettuccine"}, {"n": "Lisa C.", "t": "Excellent flavor and perfect size. I keep the fettuccine in my refrigerator to use in soups or to add to sauces.", "cat": "konjac", "prod": "Fettuccine"}, {"n": "Arlene C.", "t": "I love this product! It is amazing warmed or in a cold salad. The texture is perfect and is a staple of my diet.", "cat": "konjac", "prod": "Fettuccine"}, {"n": "Charlene B.", "t": "These are a wonderful replacement for high-calorie pasta. They really absorb the delicious taste of pasta sauce.", "cat": "konjac", "prod": "Fettuccine"}, {"n": "Heike D.", "t": "Miracle Noodle fettuccine is my favorite addition to salads and stir-fry dishes. Adds substance and fiber to the meal.", "cat": "konjac", "prod": "Fettuccine"}, {"n": "Doug W.", "t": "Just as advertised. I washed and fried the fettuccine and added Alfredo sauce, and it tasted great. A good keto dinner.", "cat": "konjac", "prod": "Fettuccine"}, {"n": "Nelson J.", "t": "Wonderful noodles that seem to absorb the flavors they're cooked with. Low calorie, with the mouth-feel of pasta.", "cat": "konjac", "prod": "Fettuccine"}, {"n": "Deanna H.", "t": "This makes a really tasty fried rice! I rinse it well, then sauté it with veggies, add a little soy sauce — delish!", "cat": "konjac", "prod": "Konjac Rice"}, {"n": "Angie M.", "t": "I can't get enough of it. It's been so helpful to have a substitute for refined carbs without compromising taste.", "cat": "konjac", "prod": "Konjac Rice"}, {"n": "Susan C.", "t": "I love all the miracle noodle products. I use them in place of any conventional noodle. They are my best diet secret.", "cat": "konjac", "prod": "Konjac Rice"}, {"n": "Mary M.", "t": "I really do love this rice. It is delicious and ready for me to eat right away — so easy! This is a wonderful product.", "cat": "konjac", "prod": "Konjac Rice"}, {"n": "Liborio G.", "t": "What I like the most about the rice is how easy it is to prepare. It's quick, and it pairs with just about anything.", "cat": "konjac", "prod": "Konjac Rice"}, {"n": "Jenna V.", "t": "Only used the rice so far, but my hubby is a picky eater and didn't mention it (which is good) and ate all his food!", "cat": "konjac", "prod": "Konjac Rice"}, {"n": "Mark M.", "t": "We have been eating the Pad Thai and Green Curry noodles and they are great! Tried the Japanese Curry. Fantastic!!!", "cat": "konjac", "prod": "Miracle Noodle"}, {"n": "Sawnya A.", "t": "I love the Pad Thai flavor of miracle noodles. I love feeling full and satisfied after consuming so few calories.", "cat": "konjac", "prod": "Miracle Noodle"}, {"n": "Leslie B.", "t": "These are easy to prepare and make for a quick meal. They taste good. I like to have them on hand for a quick bite.", "cat": "konjac", "prod": "Miracle Noodle"}, {"n": "Beth L.", "t": "These noodles are easy to prepare, gluten free, and low in oxalates and lectins. Perfect for those of us avoiding these!", "cat": "konjac", "prod": "Miracle Noodle"}, {"n": "Don T.", "t": "Following a low-carb program and loving pasta is a tough combination. Miracle Noodle spaghetti is a great help.", "cat": "egg", "prod": "Egg White Spaghetti"}, {"n": "Bonnie B.", "t": "My order was delivered before the week was over! I've ordered several times and every time they arrive within a week.", "cat": "egg konjac", "prod": "Miracle Noodle"}, {"n": "Erin G.", "t": "They are easy to order and you can sign up for auto-ship with a discount! It doesn't get much easier than that!!", "cat": "egg konjac", "prod": "Miracle Noodle"}, {"n": "Kelley W.", "t": "I love the Penne for pasta salads and other dishes that I make often. It works much better than I expected.", "cat": "egg konjac", "prod": "Miracle Noodle"}, {"n": "georgie h.", "t": "I absolutely love these noodles! Being able to have noodles with very few ingredients is great.", "cat": "egg", "prod": "Egg White Spaghetti"}, {"n": "marlene d.", "t": "I like to use it as a different option for a meal — tomato sauce, or seasoned however I like it.", "cat": "konjac", "prod": "Angel Hair"}, {"n": "Marie W.", "t": "I love my pasta and rice, so Miracle Noodles are a great replacement when you want to reduce carbs and calories.", "cat": "konjac", "prod": "Konjac Rice"}, {"n": "JAMIE B.", "t": "Love this rice. I don't care for regular rice, and this is low calorie and goes great with everything I make.", "cat": "konjac", "prod": "Konjac Rice"}, {"n": "Nancyelizabeth G.", "t": "I love these. I put a tiny bit of cream cheese on top. Great product.", "cat": "egg konjac", "prod": "Miracle Noodle"}];
  var esc=function(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');};
  MORE.forEach(function(r){
    var a=document.createElement('article');
    a.className='rcrd'; a.setAttribute('data-rating','5'); a.setAttribute('data-photo','0'); a.setAttribute('data-cat',r.cat);
    a.innerHTML='<div class="rcrd__stars">★★★★★</div><blockquote>"'+esc(r.t)+'"</blockquote>'+
      '<div class="rcrd__foot"><span class="rcrd__name">'+esc(r.n)+'</span><span class="rcrd__vb">Verified Buyer</span><span>'+esc(r.prod)+'</span></div>';
    wall.appendChild(a);
  });
})();

/* review wall filtering */
(function(){
  var wall=document.querySelector('.rev-wall'); if(!wall) return;
  var cards=[].slice.call(wall.querySelectorAll('.rcrd'));
  var btns=[].slice.call(document.querySelectorAll('.rev-filters button'));
  var countEl=document.querySelector('[data-rev-count]');
  var TOTAL='14,000+';
  function apply(f){
    var shown=0;
    cards.forEach(function(c){
      var ok = f==='all' ? true
        : /^\d$/.test(f) ? (+c.dataset.rating===+f)
        : f==='photo' ? (c.dataset.photo==='1')
        : (c.dataset.cat||'').indexOf(f)>-1;
      c.style.display = ok ? '' : 'none';
      if(ok) shown++;
    });
    if(countEl) countEl.textContent = shown
      ? 'Showing '+shown+' of our favorites — from '+TOTAL+' verified reviews'
      : 'No reviews at this rating in the curated set — the full history lives on each product page';
  }
  btns.forEach(function(b){ b.addEventListener('click',function(){
    btns.forEach(function(x){x.classList.remove('is-active');});
    b.classList.add('is-active');
    apply(b.dataset.filter);
  });});
  apply('all');
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-scrolly"]) return;
  try {
    
/* Signature: scroll-driven line draw (retired) */
(function(){
  var sec=document.querySelector('.scrolly'); if(!sec) return;
  var svgEl=sec.querySelector('.scrolly__svg');
  var setVB=function(){ if(svgEl) svgEl.setAttribute('viewBox', matchMedia('(max-width:700px)').matches ? '150 8 540 444' : '0 0 1000 460'); };
  setVB(); window.addEventListener('resize',setVB,{passive:true});
  var reg=document.getElementById('line-reg'), mn=document.getElementById('line-mn');
  var cartReg=document.getElementById('cart-reg'), heartMn=document.getElementById('heart-mn');
  if(!reg||!mn) return;
  var caps=[].slice.call(sec.querySelectorAll('.scap'));
  var clamp=function(v,a,b){return Math.max(a,Math.min(b,v));};
  var rL=reg.getTotalLength(), mL=mn.getTotalLength();
  reg.style.strokeDasharray=rL; mn.style.strokeDasharray=mL;
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(reduce){ reg.style.strokeDashoffset=0; mn.style.strokeDashoffset=0; caps.forEach(function(c){c.classList.add('on');}); sec.classList.add('lit'); var cz=document.getElementById('caliper'); if(cz)cz.classList.add('on'); var sz=sec.querySelector('[data-share-row]'); if(sz)sz.classList.add('on'); return; }
  reg.style.strokeDashoffset=rL; mn.style.strokeDashoffset=mL;
  function drawLine(path,len,marker,p,scale,rot){
    path.style.strokeDashoffset=len*(1-p);
    if(!marker) return;
    if(p>0.004&&p<0.996){
      var pt=path.getPointAtLength(len*p);
      var tf='translate('+pt.x.toFixed(1)+','+pt.y.toFixed(1)+')';
      if(rot) tf+=' rotate('+rot.toFixed(1)+')';
      if(scale&&scale!==1) tf+=' scale('+scale.toFixed(3)+')';
      marker.setAttribute('transform',tf);
      marker.style.opacity=1;
    } else marker.style.opacity=0;
  }
  function regProgress(prog){
    if(prog<=0.08) return 0;
    if(prog<0.30){ var t=(prog-0.08)/0.22; return 0.42*(1-(1-t)*(1-t)); }
    if(prog<0.36) return 0.42;
    if(prog<0.58){ var t=(prog-0.36)/0.22; return 0.42+0.58*t*t; }
    return 1;
  }
  var ticking=false;
  function update(){
    ticking=false;
    var total=sec.offsetHeight-window.innerHeight;
    var prog=clamp(-sec.getBoundingClientRect().top/total,0,1);
    var pulse=(prog>0.27&&prog<0.40)?1-Math.abs(prog-0.335)/0.065:0;
    var rp=regProgress(prog);
    var derail=rp>0.45?clamp((rp-0.45)/0.45,0,1):0;
    drawLine(reg,rL,cartReg,rp,1+0.16*Math.max(0,pulse)+0.34*derail,derail*30);
    drawLine(mn,mL,heartMn,clamp((prog-0.08)/0.55,0,1),1);
    sec.classList.toggle('lit', prog>0.02);
    var cal=document.getElementById('caliper'); if(cal) cal.classList.toggle('on', prog>=0.40 && prog<0.66);
    caps[0].classList.toggle('on', prog>=0.08 && prog<0.30);
    caps[1].classList.toggle('on', prog>=0.30 && prog<0.55);
    caps[2].classList.toggle('on', prog>=0.55);
    var shareRow=sec.querySelector('[data-share-row]'); if(shareRow) shareRow.classList.toggle('on', prog>=0.62);
  }
  window.addEventListener('scroll',function(){ if(!ticking){ requestAnimationFrame(update); ticking=true; } },{passive:true});
  window.addEventListener('resize',update); update();
})();

/* The Doctor's Chart — exportable branded PNG of the diverged frame */
(function(){
  var btn=document.querySelector('[data-sharechart]'); if(!btn) return;
  btn.addEventListener('click',function(){
    var W=1080,H=1350,c=document.createElement('canvas'); c.width=W;c.height=H;var x=c.getContext('2d');
    x.fillStyle='#f4efe6';x.fillRect(0,0,W,H);
    x.fillStyle='#13202c';x.font='600 30px "Plex Mono",monospace';x.fillText('WHAT IS IN THE BOWL',90,120);
    x.font='400 78px Georgia,serif';x.fillText('Regular pasta: refined flour.',90,250);
    x.fillStyle='#1c66a3';x.font='italic 400 78px Georgia,serif';x.fillText('This: protein or fiber.',90,338);
    var ox=120,oy=470,cw=840,ch=520;
    x.strokeStyle='#dcd4c2';x.lineWidth=1.5;
    for(var i=0;i<4;i++){var gy=oy+ch*i/3;x.beginPath();x.moveTo(ox,gy);x.lineTo(ox+cw,gy);x.stroke();}
    x.setLineDash([6,8]);x.beginPath();x.moveTo(ox,oy+ch*0.62);x.lineTo(ox+cw,oy+ch*0.62);x.stroke();x.setLineDash([]);
    x.strokeStyle='#cda970';x.lineWidth=11;x.lineCap='round';x.beginPath();x.moveTo(ox+20,oy+ch*0.66);
    x.bezierCurveTo(ox+260,oy+ch*0.08,ox+340,oy+ch*0.08,ox+440,oy+ch*0.42);
    x.bezierCurveTo(ox+560,oy+ch*0.92,ox+700,oy+ch*0.82,ox+cw,oy+ch*0.80);x.stroke();
    x.strokeStyle='#57BDE9';x.beginPath();x.moveTo(ox+20,oy+ch*0.62);x.lineTo(ox+cw,oy+ch*0.60);x.stroke();
    x.strokeStyle='#57BDE9';x.lineWidth=2;x.beginPath();x.moveTo(ox+440,oy+ch*0.42);x.lineTo(ox+440,oy+ch*0.62);x.stroke();
    x.fillStyle='#57BDE9';x.font='500 26px "Plex Mono",monospace';x.fillText('the gap',ox+460,oy+ch*0.5);
    x.fillStyle='#13202c';x.font='400 40px Georgia,serif';x.fillText('Egg white: under 1g carb. Konjac: 1g net carb.',90,1140);
    x.fillStyle='#5b646f';x.font='500 26px "Plex Mono",monospace';x.fillText('MIRACLE NOODLE  ·  curated by JONATHAN CARP, MD',90,1210);
    c.toBlob(function(blob){
      if(!blob) return;
      var file=new File([blob],'miracle-noodle-label.png',{type:'image/png'});
      if(navigator.canShare&&navigator.canShare({files:[file]})){
        navigator.share({files:[file],text:'What is in the bowl. — Miracle Noodle'}).catch(function(){});
      } else { var a=document.createElement('a');a.href=URL.createObjectURL(blob);a.download='miracle-noodle-label.png';a.click(); }
    },'image/png');
  });
})();

  } catch(e) { console.error(e); }
})();
})();
